import { ca } from '@cian/analytics';

import type { IOfferSnippetSchema } from 'shared/repositories/commercial-search-offers/entities/offer_snippet/OfferSnippetSchema';

import { CAROUSEL_PLACE } from '../../../../constants';
import { SPECIAL_PROJECT_CAROUSEL_OPTIONS } from '../constants';
import { getSpecialProjectOffersPositions } from '../utils/getSpecialProjectOffersPositions';

export function trackPromoBuilderOffersShow({
  realtyUserId,
  title,
  builderCardUrl,
  offers,
}: {
  realtyUserId: number;
  title: string;
  builderCardUrl: string;
  offers: IOfferSnippetSchema[];
}): void {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show_sopr',
    label: 'specproject_carousel',
    page: {
      extra: {
        is_specproject: true,
        content: getSpecialProjectOffersPositions({
          step: SPECIAL_PROJECT_CAROUSEL_OPTIONS.slidesPerView,
          activeSlideIndex: 0,
          offers,
        }),
        hit_url: builderCardUrl,
        carousel_name: title,
        carousel_place: CAROUSEL_PLACE,
      },
    },
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
}
